import { render, staticRenderFns } from "./LinkButton.vue?vue&type=template&id=09ff59f4&"
import script from "./LinkButton.vue?vue&type=script&lang=ts&"
export * from "./LinkButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports